import { FC } from "react";

import { Box, Button } from "@portex-pro/ui-components";
import Text from "components/Text";
import { ChatMessage, DraftAttachment } from "types/Chat";

import { useChatContentStyles } from "./chatStyles";
import MessagesListView from "./Messages/MessagesListView";
import NewMessageInputContainer from "./NewChatMessageInput/NewMessageInputContainer";

interface ChatContentViewProps {
  messages: ChatMessage[];
  addMessage: (message: string) => void;
  isSending?: boolean;
  draftAttachments: DraftAttachment[];
  hideFileAttachments?: boolean;
  isStarted: boolean;
  handleStartConversation: () => void;
}

const ChatContentView: FC<ChatContentViewProps> = ({
  messages,
  addMessage,
  isSending = false,
  draftAttachments,
  hideFileAttachments = false,
  isStarted,
  handleStartConversation,
}) => {
  const classes = useChatContentStyles();

  return (
    <Box className={classes.wrapper}>
      {isStarted ? (
        <>
          <MessagesListView messages={messages} isSending={isSending} />
          <NewMessageInputContainer
            onSendMessage={addMessage}
            isSending={isSending}
            draftAttachments={draftAttachments}
            hideFileAttachments={hideFileAttachments}
          />
        </>
      ) : (
        <div className="w-full h-full flex items-center justify-center flex-col space-y-3">
          <Text size="medium" typographyProps={{ color: "textSecondary" }}>
            This conversation hasn't been started yet
          </Text>
          <Button variant="contained" color="primary" onClick={handleStartConversation}>
            Start Conversation
          </Button>
        </div>
      )}
    </Box>
  );
};

export default ChatContentView;
